import React from 'react';

const Loader = () => {

    return (
        <div className="App">
            <header className="App-header">
                <div className="App-intro">
                    <div className="spinner-border text-white" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Loader;


